var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"TRC-ReturnCentreDown"},[_c('div',{staticClass:"TRC-ReturnCentreDown__Alert"},[_c('div',[_vm._v("The trade-in portal is currently not available.")]),_vm._v(" "),_c('div',[_vm._v("Please contact the merchant for further information.")])])])
}]

export { render, staticRenderFns }